export function createArray<T>(length: number, creator: (index: number) => T) {
  return new Array(length).fill(0).map((_, index) => creator(index));
}
